export const bytesInMb = 1000000;
export const bytesInKb = 1000;
export const maxTotalFileSize = 200 * bytesInMb; // 200MB
